<!-- クーポン選択 -->
<template>
  <!-- 所持しているクーポンの一覧 -->
  <TemplateMfittSelectPaymentMethod v-if="isReadyToDraw" />

  <!-- 描画ローディング -->
  <DialogInitialLoading v-else :timeoutSeconds="7000" />
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import TemplateMfittSelectPaymentMethod from "@/views/Templates/MFITT/TemplateMfittSelectPaymentMethod";

import nativeHandlerService from "@/services/nativeHandler";

// API
import API from "@/API";

export default {
  name: "MfittSelectPaymentMethod",
  components: {
    TemplateMfittSelectPaymentMethod,
  },
  setup() {
    const store = useStore();

    // ログインしているかどうか
    const isLogin = store.getters["common/isLogin"];

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      if (!isLogin) {
        // 未ログインの場合はダイアログ
        nativeHandlerService.returnNativeAppToAccountPage();
        // 未ログインのダイアログは、ダイアログ外を押しても閉じてしまうので、対策として10秒後にネイティブに戻る
        setTimeout(backToMfittIndexPage, 10000);
      } else {
        await API.getPaymentMethods();
        isReadyToDraw.value = true;
      }
    });

    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    return {
      isReadyToDraw,
      backToMfittIndexPage,
    };
  },
};
</script>
